export default __webpack_public_path__ + "static/media/box-3Closed.454e1484.jpg";